import { Component } from '@angular/core';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-scenario-chart',
  templateUrl: './scenario-chart.component.html',
  styleUrls: ['./scenario-chart.component.scss']
})
export class ScenarioChartComponent {

  constructor(
    public _autoMl:AutoMlService
  ){}

  get scenarioList(){
    return this._autoMl.iterationSet[this._autoMl.iterationSet.length -1].scenarioList;
  }



}
